module.exports = __webpack_public_path__ + "img/Free-Quick-Perks-Courses.8f6f47d8.png";